<template>
  <div class="personRegister">
    <div id="header" class="header">
      <div class="header-main main">
        <span class="logo" @click="$router.replace('/')">
          <img src="@/assets/sp_logo.png" alt="">
        </span>
        <span class="head-title">个人注册</span>
      </div>
    </div>
    <section class="main">
      <div class="form-item">
        <label class="label"><i class="required">*</i>手机号</label>
        <div class="input-box">
          <input class="input" v-model.trim="form.linkPhone" type="text" placeholder="联系人手机号">
        </div>
      </div>
      <div id="captcha"></div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>验证码</label>
        <div class="input-box">
          <input class="input code-input" v-model.trim="form.validateCode" type="text" placeholder="手机验证码">
          <button class="btn-code" :disabled="btnDisabled" @click="getCode">{{codeBtnText}}</button>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>密码</label>
        <div class="input-box">
          <input class="input" v-model.trim="form.password" type="password" placeholder="密码" @blur="checkPassword">
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>再次输入密码</label>
        <div class="input-box">
          <input class="input" v-model.trim="password" type="password" placeholder="再次输入密码" @blur="checkPassword">
        </div>
      </div>
      <div class="form-item">
        <label class="label"></label>
        <div class="input-box">
          <el-checkbox v-model="form.isAgree" class="agree-deal" :true-label="1" :false-label="0">
            <span class="agree">我已阅读并同意</span>
            <a class="deal" target="_blank" href="/Help/helpCenter_09.html">《工业速派使用协议》、</a>
            <a class="deal" target="_blank" href="/Help/helpCenter_12.html">《工业速派隐私权条款》</a>
          </el-checkbox>
        </div>
      </div>
      <div class="form-item">
        <span class="label"></span>
        <div class="input-box">
          <button class="btn-primary" @click="submit">加入速派</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {isDev,BASEURL,p_origin,personUrl} from '@/scripts/util.js'
import validate from '@/scripts/validate.js'
import {aesEncrypt} from '@/scripts/aesHelper.js'
import {
  UserRegister,
  LoginAjax,
  UserAccountLogin,
  SendMobileCode,
} from '@/scripts/api.js';
let _dx=window._dx;
export default {
  name: 'personRegister',
  data(){
    return{
      form:{
        linkPhone:'',
        password:'',
        validateCode:'',
        isAgree:0,
      },
      password:'',
      codeBtnText: "获取验证码",
      btnDisabled: false,
      timer: null,
      imgCodeToken:'',
    }
  },
  created() {
    this.login();
  },
  methods: {
    checkPassword() {
      if (this.form.password == "") {
        return;
      }
      if (this.password == "") {
        return;
      }
      if(!validate.password(this.form.password)){
        this.$toast('密码为6-14位数字字母组合');
        return;
      }
      if (this.password != this.form.password) {
        this.$toast("密码不一致，请重新输入！");
        this.password = "";
        return;
      }
    },
    //获取验证码
    getCode() {
      var self = this;
      if (this.form.linkPhone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.form.linkPhone !== "" &&
        !validate.phone(this.form.linkPhone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      var myCaptcha = _dx.Captcha(document.getElementById('captcha'), {
          appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
          style: 'inline',
          success: function (token) {
            SendMobileCode({
              phone: self.form.linkPhone,
              codeType:104,
              imgCodeToken:token,
              platform:'pcweb'
            }).then(r => {
              // myCaptcha.hide();
              if (r.Result == 1) {
                let time = 120;
                self.btnDisabled = true;
                self.timer = setInterval(() => {
                  time--;
                  self.codeBtnText = time + "s";
                  if (time <= 0) {
                    time = 120;
                    self.btnDisabled = false;
                    self.codeBtnText = "获取验证码";
                    clearInterval(self.timer);
                  }
                }, 1000);
                self.$toast(r.Message);
              } else {
                self.$toast(r.Message);
              }
            });
          },
          fail:function(err){
            console.log(err)
          }
      })
      myCaptcha.show();
    },
    //提交
    submit() {
      if (this.form.linkPhone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.form.linkPhone !== "" &&
        !validate.phone(this.form.linkPhone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (this.form.validateCode === "") {
        this.$toast("请输入手机验证码！");
        return;
      }
      if(!validate.password(this.form.password)){
        this.$toast('密码为6-20位数字字母组合');
        return;
      }
      if (this.password != this.form.password) {
        this.$toast("密码不一致，请重新输入！");
        return;
      }
      if (!this.form.isAgree) {
        this.$toast('请阅读并同意工业速派使用协议,工业速派隐私权条款');
        return;
      }
      let obj = {
        AppId: 101001,
        RegisterMode:1,//个人
        HandSet: this.form.linkPhone,
        PassWord: this.form.password,
        ValidateCode: this.form.validateCode,
        platform:'pcweb',
      }
      UserRegister(obj).then(r => {
        if(r.Result==1){
          this.$toast(r.Message);
          this.login();
        }else{
          this.$toast(r.Message);
        }
      });
    },
    login(){
      window.$.getJSON(personUrl+'/user/LoginAjax?callback=?',{
        Resource: 16, 
        LoginKey: this.form.linkPhone, 
        Password: aesEncrypt(this.form.password)
      },function (data) {
        if(data && data.IsLogin){
          UserAccountLogin({
            LoginName:data.Account,
            Password:data.Password,
            AppId:100101,
          }).then(r=>{
              if(r && r.IsLogin){
                this.$router.push('/home');
              }
          })
        }
      })
    }
  },
}
</script>
<style lang="scss">
.personRegister{
  background-color: #fff;
  padding-top: 110px;
  padding-bottom: 48px;
  #header {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #f75959;
    border-bottom: 1px solid #ccc \0;
    -webkit-box-shadow: 0 0 20px rgba(8,1,3,0.16);
    -moz-box-shadow: 0 0 20px rgba(8,1,3,0.16);
    -o-box-shadow: 0 0 20px rgba(8,1,3,0.16);
    box-shadow: 0 0 20px rgba(8,1,3,0.16);
    .header-main {
      margin: 0 auto;
      height: 68px;
    }
    .header-l {
      float: left;
      overflow: hidden;
    }
    .logo {
      float: left;
      width: 131px;
      height: 37px;
      margin-top: 15px;
    }
    .head-title {
      float: left;
      font-size: 16px;
      color: #333;
      height: 36px;
      line-height: 36px;
      margin-top: 16px;
      margin-left: 10px;
      padding-left: 10px;
    }
  }
  >.main{
    padding: 64px 100px 40px;
    width: 1000px;
    min-height: 600px;
    background-color: #f9f9f9;
  }
  #captcha{
    margin-left: 120px;
    position: relative;
    z-index: 10;
    margin-bottom: 20px;
  }
  .form-item{
    margin-bottom: 20px;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .label{
    float: left;
    min-width: 100px;
    height: 38px;
    margin-right: 20px;
    font-size: 14px;
    color: #666;
    line-height: 38px;
  }
  .input-box{
    float: left;
    min-width: 500px;
    position: relative;
  }
  .input{
    display: block;
    width: 100%;
    height: 38px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    &:read-only{
      cursor: not-allowed;
      background-color: #f5f5f5;
    }
    &:focus{
      border-color: #f75959;
    }
    &.code-input{
      padding-right: 130px;
    }
  }
  .textarea{
    display: block;
    width: 100%;
    height: 100px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    resize: none;
    &:read-only{
      cursor: not-allowed;
      background-color: #f5f5f5;
    }
    &:focus{
      border-color: #f75959;
    }
    &.code-input{
      padding-right: 130px;
    }
  }
  .btn-code{
    position: absolute;
    right: 0;
    top: 0;
    width: 120px;
    height: 38px;
    background-color: #D5D5D5;
    color: #666;
    font-size: 14px;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
  }
  .btn-default{
    display: inline-block;
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 36px;
    background-color: #fff;
    border: 1px solid #f75959;
    border-radius: 2px;
    color: #f75959;
    font-size: 14px;
    margin-right: 20px;
  }
  .btn-primary{
    display: inline-block;
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background-color: #f75959;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
  }
  .agree-deal{
    font-size: 14px;
    .el-checkbox__input{
      vertical-align: middle;
    }
    .el-checkbox__original{
      display: none;
    }
    &.is-checked{
      .el-checkbox__inner{
         background-color: #409eff;
        border-color: #409eff;
        &:after{
          content: "";
          width: 3px;
          height: 7px;
          border-right: 1px solid #fff;
          border-bottom: 1px solid #fff;
          position: absolute;
          left: 4px;
          top: 1px;
          z-index: 2;
          transform: rotate(45deg);
          // transition: transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;
          // transform-origin: center;
          box-sizing: content-box;
        }
      }
    }
    .el-checkbox__inner{
      display: inline-block;
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      box-sizing: border-box;
      width: 16px;
      height: 16px;
      background-color: #fff;
      z-index: 1;
      transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
      
    }
    .agree{
      color: #333;
      padding-left: 6px;
    }
    .deal{
      color: #f75959;
    }
  }
}
</style>